import { action, makeObservable, onBecomeObserved, override } from "mobx"

import { TransactionsBanksPayouts } from "@src/pages/transactionsBankPayouts/constants"
import { bankPayoutsApi, catchErrors, massPayoutsApi } from "@src/shared/api"
import { BankPayoutResponse, Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"
import { CollectionFilters } from "@src/shared/componemts/TableFilter/classes/CollectionFilters"

export type BanksPayoutsLoadRequest = {
  date?: {
    dateFrom?: string
    dateTo?: string
  }
  externalId?: string
  order?: "asc" | "desc"
  page?: number
}

export type MassPayoutsFilters = {
  date?: {
    dateFrom?: string
    dateTo?: string
  }
  externalId?: string
  order?: string
}

export class BankPayoutsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<BankPayoutResponse>,
) {
  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      pagination: override,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async fetch(req: BanksPayoutsLoadRequest = {}) {
    try {
      const { page = 0 } = req

      const {
        data: { data },
      } = await bankPayoutsApi.listBankPayouts(
        req.externalId,
        req.date?.dateFrom,
        req.date?.dateTo,
        req.order,
        this.calcOffset(page),
        this.pageSize,
      )

      if (data) {
        return {
          data: data.data as BankPayoutResponse[],
          pagination: data.pagination as Pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  get filter() {
    return new CollectionFilters<MassPayoutsFilters>(
      TransactionsBanksPayouts,
      this.load,
    )
  }
}
